<template>
  <table>
    <colgroup>
      <col class="col" />
      <col class="col" />
      <col class="col" />
      <col class="col" />
      <col class="col" />
      <col class="col" />
      <col class="col" />
      <col class="col" />
      <col class="col" />
      <col class="col" />
    </colgroup>
    <tbody>
      <!-- row 1 -->
      <tr>
        <td></td>
        <td></td>
        <td class="cell" colspan="2">
          {{ $store.state.labels.evaluations.amount }}（全顧客）
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 2 -->
      <tr>
        <td></td>
        <td></td>
        <td class="cell" :class="[evalAmountTotal]" colspan="2">
          {{ amountTotal | formatNumeric('0,0') }}
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 3 -->
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-v"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 4 -->
      <tr>
        <td></td>
        <td></td>
        <td class="cell" colspan="2">
          {{ $store.state.labels.evaluations.amount }}（選択顧客）
        </td>
        <td class="line-h"></td>
        <td class="cell" colspan="2">
          構成比
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 5 -->
      <tr>
        <td></td>
        <td></td>
        <td class="cell" :class="[evalAmount]" colspan="2">
          {{ amount | formatNumeric('0,0') }}
        </td>
        <td></td>
        <td class="cell" :class="[evalCompositionRatio]" colspan="2">
          {{ compositionRatio | formatNumeric('0,0.00%') }}
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 6 -->
      <tr>
        <td></td>
        <td class="line-h"></td>
        <td class="line-h"></td>
        <td class="line-v line-h"></td>
        <td class="line-h"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 7 -->
      <tr>
        <td></td>
        <td class="line-v"></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-v"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 8 -->
      <tr>
        <td class="cell badge" :class="badgesCustomerCount" colspan="2">
          <query-roots-tree-detail-menu
            v-if="enableEvaluationClick && enableCustomerLinkClick"
            :text="$store.state.labels.evaluations.customer_count"
            @select="emitEvaluationClick('customerCount', $event)"
          />
          <div
            v-else-if="enableEvaluationClick"
            class="pointer"
            :gl-tooltip="msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE"
            gl-tooltip-direction="up"
          >
            <span>
              {{ $store.state.labels.evaluations.customer_count }}
            </span>
          </div>
          <span v-else>
            {{ $store.state.labels.evaluations.customer_count }}
          </span>
        </td>
        <td></td>
        <td></td>
        <td class="cell" colspan="2">
          <query-roots-tree-detail-menu
            v-if="enableEvaluationClick && enableCustomerLinkClick"
            :text="$store.state.labels.evaluations.amount_per_customer"
            @select="emitEvaluationClick('amountPerCustomer', $event)"
          />
          <div
            v-else-if="enableEvaluationClick"
            class="pointer"
            :gl-tooltip="msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE"
            gl-tooltip-direction="up"
          >
            <span>
              {{ $store.state.labels.evaluations.amount_per_customer }}
            </span>
          </div>
          <span v-else>
            {{ $store.state.labels.evaluations.amount_per_customer }}
          </span>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 9 -->
      <tr>
        <td class="cell" :class="[evalCustomerCount]" colspan="2">
          <a
            v-if="customerCount > 0 && enableCustomerLinkClick"
            href="#"
            @click.prevent="$emit('customer-count-link-click')"
          >
            {{ customerCount | formatNumeric('0,0') }}
          </a>
          <div
            v-else-if="customerCount > 0"
            class="pointer"
            :gl-tooltip="msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE"
            gl-tooltip-direction="down"
          >
            <span>
              {{ customerCount | formatNumeric('0,0') }}
            </span>
          </div>
          <span v-else>
            {{ customerCount | formatNumeric('0,0') }}
          </span>
        </td>
        <td></td>
        <td></td>
        <td class="cell" :class="[evalAmountPerCustomer]" colspan="2">
          {{ amountPerCustomer | formatNumeric('0,0.00') }}
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 10 -->
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-h"></td>
        <td class="line-h"></td>
        <td class="line-v line-h"></td>
        <td class="line-h"></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 11 -->
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-v"></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-v"></td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 12 -->
      <tr>
        <td></td>
        <td></td>
        <td class="cell badge" :class="badgesReceiptPerCustomer" colspan="2">
          <query-roots-tree-detail-menu
            v-if="enableEvaluationClick && enableCustomerLinkClick"
            :text="$store.state.labels.evaluations.receipt_per_customer"
            @select="emitEvaluationClick('receiptPerCustomer', $event)"
          />
          <div
            v-else-if="enableEvaluationClick"
            class="pointer"
            :gl-tooltip="msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE"
            gl-tooltip-direction="up"
          >
            <span>
              {{ $store.state.labels.evaluations.receipt_per_customer }}
            </span>
          </div>
          <span v-else>
            {{ $store.state.labels.evaluations.receipt_per_customer }}
          </span>
        </td>
        <td></td>
        <td></td>
        <td class="cell" colspan="2">
          <query-roots-tree-detail-menu
            v-if="enableEvaluationClick && enableCustomerLinkClick"
            :text="$store.state.labels.evaluations.amount_per_receipt"
            @select="emitEvaluationClick('amountPerReceipt', $event)"
          />
          <div
            v-else-if="enableEvaluationClick"
            class="pointer"
            :gl-tooltip="msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE"
            gl-tooltip-direction="up"
          >
            <span>
              {{ $store.state.labels.evaluations.amount_per_receipt }}
            </span>
          </div>
          <span v-else>
            {{ $store.state.labels.evaluations.amount_per_receipt }}
          </span>
        </td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 13 -->
      <tr>
        <td></td>
        <td></td>
        <td class="cell" :class="[evalReceiptPerCustomer]" colspan="2">
          {{ receiptPerCustomer | formatNumeric('0,0.00') }}
        </td>
        <td></td>
        <td></td>
        <td class="cell" :class="[evalAmountPerReceipt]" colspan="2">
          {{ amountPerReceipt | formatNumeric('0,0.00') }}
        </td>
        <td></td>
        <td></td>
      </tr>
      <!-- row 14 -->
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-h"></td>
        <td class="line-h"></td>
        <td class="line-v line-h"></td>
        <td class="line-h"></td>
        <td></td>
      </tr>
      <!-- row 15 -->
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-v"></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="line-v"></td>
      </tr>
      <!-- row 16 -->
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="cell badge" :class="badgesQtyPerReceipt" colspan="2">
          <query-roots-tree-detail-menu
            v-if="enableEvaluationClick && enableCustomerLinkClick"
            :text="$store.state.labels.evaluations.qty_per_receipt"
            @select="emitEvaluationClick('qtyPerReceipt', $event)"
          />
          <div
            v-else-if="enableEvaluationClick"
            class="pointer"
            :gl-tooltip="msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE"
            gl-tooltip-direction="up"
          >
            <span>
              {{ $store.state.labels.evaluations.qty_per_receipt }}
            </span>
          </div>
          <span v-else>
            {{ $store.state.labels.evaluations.qty_per_receipt }}
          </span>
        </td>
        <td></td>
        <td></td>
        <td class="cell badge" :class="badgesAmountPerQty" colspan="2">
          <query-roots-tree-detail-menu
            v-if="enableEvaluationClick && enableCustomerLinkClick"
            :text="$store.state.labels.evaluations.amount_per_qty"
            @select="emitEvaluationClick('amountPerQty', $event)"
          />
          <div
            v-else-if="enableEvaluationClick"
            class="pointer"
            :gl-tooltip="msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE"
            gl-tooltip-direction="up"
          >
            <span>
              {{ $store.state.labels.evaluations.amount_per_qty }}
            </span>
          </div>
          <span v-else>
            {{ $store.state.labels.evaluations.amount_per_qty }}
          </span>
        </td>
      </tr>
      <!-- row 17 -->
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="cell" :class="[evalQtyPerReceipt]" colspan="2">
          {{ qtyPerReceipt | formatNumeric('0,0.00') }}
        </td>
        <td></td>
        <td></td>
        <td class="cell" :class="[evalAmountPerQty]" colspan="2">
          {{ amountPerQty | formatNumeric('0,0.00') }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { snakeCase } from 'lodash'
import QueryRootsTreeDetailMenu from '@/components/QueryRootsTreeDetailMenu.vue'

import msg from '@/const/messages'

export default {
  components: { QueryRootsTreeDetailMenu },
  props: {
    enableEvaluationClick: {
      type: Boolean,
      default: false,
    },
    enableCustomerLinkClick: {
      type: Boolean,
      default: false,
    },
    amountTotal: {
      type: Number,
      default: 0,
    },
    amount: {
      type: Number,
      default: 0,
    },
    compositionRatio: {
      type: Number,
      default: 0,
    },
    customerCount: {
      type: Number,
      default: 0,
    },
    amountPerCustomer: {
      type: Number,
      default: 0,
    },
    receiptPerCustomer: {
      type: Number,
      default: 0,
    },
    amountPerReceipt: {
      type: Number,
      default: 0,
    },
    qtyPerReceipt: {
      type: Number,
      default: 0,
    },
    amountPerQty: {
      type: Number,
      default: 0,
    },
    ratioAmountTotal: {
      type: Number,
    },
    ratioAmount: {
      type: Number,
    },
    ratioCompositionRatio: {
      type: Number,
    },
    ratioCustomerCount: {
      type: Number,
    },
    ratioAmountPerCustomer: {
      type: Number,
    },
    ratioReceiptPerCustomer: {
      type: Number,
    },
    ratioAmountPerReceipt: {
      type: Number,
    },
    ratioQtyPerReceipt: {
      type: Number,
    },
    ratioAmountPerQty: {
      type: Number,
    },
  },
  data() {
    return {
      msg,
    }
  },
  computed: {
    evalAmountTotal() {
      return this.getSeverity('amountTotal')
    },
    evalAmount() {
      return this.getSeverity('amount')
    },
    evalCompositionRatio() {
      return this.getSeverity('compositionRatio')
    },
    evalCustomerCount() {
      return this.getSeverity('customerCount')
    },
    evalAmountPerCustomer() {
      return this.getSeverity('amountPerCustomer')
    },
    evalReceiptPerCustomer() {
      return this.getSeverity('receiptPerCustomer')
    },
    evalAmountPerReceipt() {
      return this.getSeverity('amountPerReceipt')
    },
    evalQtyPerReceipt() {
      return this.getSeverity('qtyPerReceipt')
    },
    evalAmountPerQty() {
      return this.getSeverity('amountPerQty')
    },
    badgesCustomerCount() {
      return this.getBadgeClass('customerCount')
    },
    badgesReceiptPerCustomer() {
      return this.getBadgeClass('receiptPerCustomer')
    },
    badgesQtyPerReceipt() {
      return this.getBadgeClass('qtyPerReceipt')
    },
    badgesAmountPerQty() {
      return this.getBadgeClass('amountPerQty')
    },
    badgeOrders() {
      const arr = [
        { name: 'customerCount', value: this.ratioCustomerCount },
        { name: 'receiptPerCustomer', value: this.ratioReceiptPerCustomer },
        { name: 'qtyPerReceipt', value: this.ratioQtyPerReceipt },
        { name: 'amountPerQty', value: this.ratioAmountPerQty },
      ]

      const tops = arr
        .filter(o => o.value > 1)
        .sort((o1, o2) => o2.value - o1.value)
      const bottoms = arr
        .filter(o => o.value < 1)
        .sort((o1, o2) => o1.value - o2.value)

      return [
        ...tops.map((o, i) => ({ ...o, order: i + 1 })),
        ...bottoms.map((o, i) => ({ ...o, order: i + 1 })),
      ]
    },
  },
  methods: {
    emitEvaluationClick(evaluation, y) {
      const severity = this.getSeverity(evaluation)
      let sw
      switch (severity) {
        case 'good':
        case 'decent':
          sw = 's'
          break
        case 'warn':
        case 'danger':
          sw = 'w'
          break
      }
      this.$emit('evaluation-click', snakeCase(evaluation), y, sw)
    },
    getSeverity(evaluation) {
      const attr =
        'ratio' + evaluation.slice(0, 1).toUpperCase() + evaluation.slice(1)
      const ratio = this[attr]
      if (ratio === undefined) {
        return undefined
      }

      if (ratio > 1.03) {
        return 'good'
      } else if (1.03 >= ratio && ratio >= 1) {
        return 'decent'
      } else if (1 > ratio && ratio >= 0.97) {
        return 'warn'
      } else if (0.97 > ratio) {
        return 'danger'
      }
      return undefined
    },
    getBadgeClass(evaluation) {
      const upOrDown = this.getUpOrDown(evaluation)
      const found = this.badgeOrders.find(o => o.name === evaluation)
      let order = found ? found.order : 0

      return [`badge-${upOrDown}`, `badge-${order}`]
    },
    getUpOrDown(evaluation) {
      const attr =
        'ratio' + evaluation.slice(0, 1).toUpperCase() + evaluation.slice(1)
      const ratio = this[attr]

      if (ratio > 1) {
        return 'up'
      } else if (ratio < 1) {
        return 'down'
      }

      return undefined
    },
  },
}
</script>

<style lang="scss" scoped>
table {
  border-spacing: 0;
  border-collapse: collapse;
  font-size: smaller;
  width: 0;
  table-layout: fixed;
  box-sizing: border-box;
}
td {
  height: 20px;
  text-align: center;
  box-sizing: border-box;
  border: 0;
}
.col {
  width: 60px;
}
.cell {
  border: 1px solid #a9a9a9;
  position: relative;
  background-clip: padding-box;
}
.line-v {
  border-left: 1px solid #a9a9a9;
}
.line-h {
  border-bottom: 1px solid #a9a9a9;
}

// 評価に応じたセルスタイル
.good {
  background-color: #4169e1;
  color: #ffffff;
}
.decent {
  background-color: #f0f8ff;
  color: #000000;
}
.warn {
  background-color: #ffc0cb;
  color: #000000;
}
.danger {
  background-color: #ff0000;
  color: #ffffff;
}

// 順位バッチ
.badge {
  &:after {
    position: absolute;
    color: #fff;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    line-height: 26px;
    top: -35px;
    left: 47px;
  }

  &-up:after {
    background-color: #4169e1;
  }
  &-down:after {
    background-color: #ff0000;
  }

  /* 疑似要素のcontentはjavascriptからいじれないのでここで定義 */
  /* ※表示できる順位を増やす場合はここに追加する必要がある */
  &-1:after {
    content: '1';
    width: 30px;
    height: 30px;
    line-height: 32px;
    top: -36px;
    left: 44px;
  }
  &-2:after {
    content: '2';
  }
  &-3:after {
    content: '3';
  }
  &-4:after {
    content: '4';
    width: 20px;
    height: 20px;
    line-height: 23px;
    top: -31px;
    left: 49px;
  }
}

.pointer {
  cursor: default;
  color: #999 !important;
}
</style>
